import script from "./EMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EMessage.vue?vue&type=script&setup=true&lang=ts"

import "./EMessage.vue?vue&type=style&index=0&id=1cc53b51&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc53b51"]])

export default __exports__